import styled, { css } from "styled-components"

interface IButtonsWrapperProps {
  isactivitypage?: boolean;
}

export const ButtonsWrapper = styled.div<IButtonsWrapperProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;

  .buttonCancel {
    height: 32px !important;
    border-radius: 6px !important;
    cursor: pointer !important;
  }

  .buttonConfirmWrapper {
    display: flex;
    flex-direction: row;
    align-items: center;

    .buttonSubmit {
      height: 32px !important;
      border: 6px;

      ${({isactivitypage}) => isactivitypage && css`
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      `}
    }

    .separator {
      width: 1px;
      height: 32px;
      background-color: ${({ theme }) => theme.colors.primary.primary};
      opacity: 0.24;
    }

    .buttonConfirmActions {
      width: 32px;
      height: 32px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
      margin-left: 0 !important;

      .iconConfirmActions {
        color: ${({ theme }) => theme.colors.primary.onPrimary} !important;
      }
    }
  }
`;

export const Wrapper = styled.div`
  padding-top: 24px;
  background: ${({ theme }) => theme.colors.surface.surface};
  border-radius: 10px !important;
  overflow: hidden;

  .midleHr {
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    margin-bottom: 4px;

    .titleHeader {
      font-size: 12px;
      font-weight: 600;
      line-height: 16.34px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    }

    .titleHeaderBold {
      color: ${({ theme }) => theme.colors.surface.onSurface};
    }
    
    .multipleIconHeader {
      display: flex;
      flex-direction: row;
      align-items: center;

      .viewpointButton {
        margin-left: 6px;
        padding: 0 12px;
      }

      .updateStatus {
        display: flex;
        flex-direction: row;
        align-items: center;
        
        .updateStatusSpan {
          display: flex;
          flex-direction: row;
          align-items: center;

          .updateStatusTextLoading {
            color: ${({ theme }) => theme.colors.primary.primary};
            font-size: 12px;
            line-height: 16.34px;
            font-weight: 600;
            margin-left: 8px;
            margin-right: 6px;
          }
          .updateStatusTextSave {
            color: ${({ theme }) => theme.colors.success.success};
            font-size: 12px;
            line-height: 16.34px;
            font-weight: 600;
            margin-right: 6px;
          }
          .updateStatusTextError {
            color: ${({ theme }) => theme.colors.danger.danger};
            font-size: 12px;
            line-height: 16.34px;
            font-weight: 600;
            margin-right: 6px;
          }
        }
      }
    }

    .iconHeaderAlarm {
      cursor: pointer;
    }

    .iconHeader {
      padding: 5px;
      background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
      border-radius: 5px;
      margin-left: 6px;
      border: none;
      cursor: pointer;

      &:hover {
        background-color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
      }

      .tooltipLink {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }

  .bodyForm {

    .bodyDefault {
      display: flex;
      align-items: center;
    }

    .bodyDescription {
      display: flex;
      align-self: flex-start;
    }
  }
`;

export const TooltipLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const VerticalHr = styled.hr`
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  height: auto;
  margin: 0;
`;

export const Content = styled.div`
  display: flex;
`;

export const LeftContent = styled.div`
  padding: 0 24px;
  padding-bottom: 16px;
  padding-right: 16px;
  width: 420px;
`;

export const RightContent = styled.div`
  width: 454px;
`;

export const FooterHr = styled.hr`
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  margin: 0 20px;
`;
